import React from 'react';

import type { ThemeModalState } from '../../types';

interface ThemeSelectionModalProps {
  themeModal: ThemeModalState;
  onClose: () => void;
  onSelectTheme: (theme: string) => void;
}

function ThemeSelectionModal({ themeModal, onClose, onSelectTheme }: ThemeSelectionModalProps) {
  if (!themeModal.visible) {
    return null;
  }

  return (
    <div 
      className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/40"
      onClick={onClose}
      style={{ backdropFilter: 'blur(4px)' }}
    >
      <div 
        className="max-h-[80vh] w-[90%] max-w-2xl overflow-y-auto rounded-xl border border-gray-200 bg-white p-8 shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mb-6 flex items-start justify-between border-b border-gray-200 pb-4">
          <h3 className="text-lg font-semibold text-gray-800">
            Choisissez le thème - {themeModal.moduleTitle}
          </h3>
          <button 
            className="text-xl font-bold text-gray-400 transition-colors hover:text-gray-600"
            onClick={onClose}
          >
            ×
          </button>
        </div>
        
        <p className="mb-6 text-gray-600">
          {themeModal.type === 'newsletter' 
            ? 'Sélectionnez le thème principal pour cette newsletter :'
            : 'Sélectionnez le thème pour ce module :'
          }
        </p>
        
        <div className="grid grid-cols-2 gap-4">
          {themeModal.type === 'newsletter' ? (
            <>
              <button 
                className="flex flex-col items-center gap-3 rounded-lg border-2 border-blue-200 bg-blue-50 p-6 transition-all duration-300 hover:border-blue-400 hover:bg-blue-100 hover:shadow-lg"
                onClick={() => onSelectTheme('Vente')}
              >
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-blue-500 text-2xl text-white">
                  <span role="img" aria-label="Briefcase">💼</span>
                </div>
                <div className="text-sm font-medium text-gray-800">Vente</div>
              </button>
              
              <button 
                className="flex flex-col items-center gap-3 rounded-lg border-2 border-green-200 bg-green-50 p-6 transition-all duration-300 hover:border-green-400 hover:bg-green-100 hover:shadow-lg"
                onClick={() => onSelectTheme('DPE')}
              >
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-green-500 text-2xl text-white">
                  <span role="img" aria-label="Chart">📊</span>
                </div>
                <div className="text-sm font-medium text-gray-800">DPE</div>
              </button>
              
              <button 
                className="flex flex-col items-center gap-3 rounded-lg border-2 border-orange-200 bg-orange-50 p-6 transition-all duration-300 hover:border-orange-400 hover:bg-orange-100 hover:shadow-lg"
                onClick={() => onSelectTheme('Travaux')}
              >
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-orange-500 text-2xl text-white">
                  <span role="img" aria-label="Wrench">🔧</span>
                </div>
                <div className="text-sm font-medium text-gray-800">Travaux</div>
              </button>
              
              <button
                className="flex flex-col items-center gap-3 rounded-lg border-2 border-purple-200 bg-purple-50 p-6 transition-all duration-300 hover:border-purple-400 hover:bg-purple-100 hover:shadow-lg"
                onClick={() => onSelectTheme('Vivre ensemble')}
              >
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-purple-500 text-2xl text-white">
                  <span role="img" aria-label="Community">🏘️</span>
                </div>
                <div className="text-sm font-medium text-gray-800">Vivre ensemble</div>
              </button>

              <button
                className="flex flex-col items-center gap-3 rounded-lg border-2 border-teal-200 bg-teal-50 p-6 transition-all duration-300 hover:border-teal-400 hover:bg-teal-100 hover:shadow-lg"
                onClick={() => onSelectTheme('Location')}
              >
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-teal-500 text-2xl text-white">
                  <span role="img" aria-label="Key">🔑</span>
                </div>
                <div className="text-sm font-medium text-gray-800">Location</div>
              </button>

            </>
          ) : (
            <>
              <button 
                className="flex flex-col items-center gap-3 rounded-lg border-2 border-blue-200 bg-blue-50 p-6 transition-all duration-300 hover:border-blue-400 hover:bg-blue-100 hover:shadow-lg"
                onClick={() => onSelectTheme('Transaction')}
              >
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-blue-500 text-2xl text-white">
                  <span role="img" aria-label="Briefcase">💼</span>
                </div>
                <div className="text-sm font-medium text-gray-800">Transaction</div>
              </button>
              
              <button 
                className="flex flex-col items-center gap-3 rounded-lg border-2 border-green-200 bg-green-50 p-6 transition-all duration-300 hover:border-green-400 hover:bg-green-100 hover:shadow-lg"
                onClick={() => onSelectTheme('Gestion Locative')}
              >
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-green-500 text-2xl text-white">
                  <span role="img" aria-label="House">🏠</span>
                </div>
                <div className="text-sm font-medium text-gray-800">Gestion Locative</div>
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default ThemeSelectionModal;
